import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FiHeart, FiFilter, FiX, FiChevronDown, FiChevronUp, FiGrid, FiList, FiStar } from 'react-icons/fi';
import { addToWishlist, removeFromWishlist } from '../store/wishlistSlice';
import { addToCart } from '../store/cartSlice';
import { toast } from 'react-toastify';
import api from '../services/api';
import './ProductList.css';

const MOCK_PRODUCTS = [
  { id: 1, name: 'Floral Print Maxi Dress', brand: 'Zara', price: 2499, originalPrice: 4999, imageEmoji: '👗', imageUrl: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=400&h=500&fit=crop&q=80', rating: 4.3, reviewCount: 128, sizes: ['XS','S','M','L','XL'], colors: ['Red','Blue','Green'], category: 'women', subcategory: 'dresses', color: 'Red', isNew: true },
  { id: 2, name: 'Slim Fit Cotton Shirt', brand: 'H&M', price: 1299, originalPrice: 2599, imageEmoji: '👔', imageUrl: 'https://images.unsplash.com/photo-1594938298603-c8148c4b4415?w=400&h=500&fit=crop&q=80', rating: 4.1, reviewCount: 89, sizes: ['S','M','L','XL','XXL'], colors: ['Blue','White','Pink'], category: 'men', subcategory: 'shirts', color: 'Blue' },
  { id: 3, name: 'High Waist Denim Jeans', brand: "Levi's", price: 3499, originalPrice: 5999, imageEmoji: '👖', imageUrl: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=500&fit=crop&q=80', rating: 4.5, reviewCount: 234, sizes: ['28','30','32','34','36'], colors: ['Blue','Black','Grey'], category: 'men', subcategory: 'jeans', color: 'Blue' },
  { id: 4, name: 'Embroidered Kurti Set', brand: 'Biba', price: 1899, originalPrice: 3499, imageEmoji: '👘', imageUrl: 'https://images.unsplash.com/photo-1583482183071-9e174c8ba40b?w=400&h=500&fit=crop&q=80', rating: 4.4, reviewCount: 156, sizes: ['XS','S','M','L','XL'], colors: ['Pink','Blue','Yellow'], category: 'women', subcategory: 'kurtis', color: 'Pink', isNew: true },
  { id: 5, name: 'Running Sports Shoes', brand: 'Nike', price: 4999, originalPrice: 8999, imageEmoji: '👟', imageUrl: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=500&fit=crop&q=80', rating: 4.6, reviewCount: 312, sizes: ['6','7','8','9','10','11'], colors: ['Black','White','Blue'], category: 'men', subcategory: 'footwear', color: 'Black' },
  { id: 6, name: 'Bohemian Wrap Skirt', brand: 'Forever 21', price: 999, originalPrice: 2499, imageEmoji: '👗', imageUrl: 'https://images.unsplash.com/photo-1583496661160-fb5218db1e1f?w=400&h=500&fit=crop&q=80', rating: 4.0, reviewCount: 67, sizes: ['XS','S','M','L'], colors: ['Yellow','Orange','Multicolor'], category: 'women', subcategory: 'skirts', color: 'Yellow' },
  { id: 7, name: 'Graphic Print T-Shirt', brand: 'Puma', price: 799, originalPrice: 1599, imageEmoji: '👕', imageUrl: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=500&fit=crop&q=80', rating: 4.2, reviewCount: 98, sizes: ['S','M','L','XL'], colors: ['White','Black','Grey'], category: 'men', subcategory: 't-shirts', color: 'White' },
  { id: 8, name: 'Silk Blend Saree', brand: 'Craftsvilla', price: 5499, originalPrice: 9999, imageEmoji: '🥻', imageUrl: 'https://images.unsplash.com/photo-1605518215734-90a5aa1a7fa5?w=400&h=500&fit=crop&q=80', rating: 4.7, reviewCount: 445, sizes: ['Free Size'], colors: ['Red','Gold','Purple'], category: 'women', subcategory: 'sarees', color: 'Green' },
  { id: 9, name: 'Leather Handbag', brand: 'Caprese', price: 2999, originalPrice: 5999, imageEmoji: '👜', imageUrl: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400&h=500&fit=crop&q=80', rating: 4.3, reviewCount: 178, sizes: ['Free Size'], colors: ['Brown','Black','Tan'], category: 'women', subcategory: 'accessories', color: 'Brown' },
  { id: 10, name: 'Kids Cartoon Tee', brand: 'H&M', price: 599, originalPrice: 1199, imageEmoji: '👕', imageUrl: 'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=400&h=500&fit=crop&q=80', rating: 4.4, reviewCount: 67, sizes: ['2-3Y','4-5Y','6-7Y','8-9Y'], colors: ['White','Pink','Blue'], category: 'kids', color: 'Multicolor', isNew: true },
  { id: 11, name: 'Formal Blazer', brand: 'Van Heusen', price: 3999, originalPrice: 7999, imageEmoji: '🧥', imageUrl: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&h=500&fit=crop&q=80', rating: 4.5, reviewCount: 89, sizes: ['S','M','L','XL'], colors: ['Navy','Charcoal','Black'], category: 'men', subcategory: 'blazers', color: 'Navy' },
  { id: 12, name: 'Strappy Block Heels', brand: 'Steve Madden', price: 2799, originalPrice: 5599, imageEmoji: '👠', imageUrl: 'https://images.unsplash.com/photo-1535043934128-cf0b28d52f95?w=400&h=500&fit=crop&q=80', rating: 4.1, reviewCount: 123, sizes: ['UK4','UK5','UK6','UK7','UK8'], colors: ['Nude','Black','Brown'], category: 'women', subcategory: 'footwear', color: 'Nude', isNew: true },
  { id: 13, name: 'Linen Trousers', brand: 'Mango', price: 2199, originalPrice: 3999, imageEmoji: '👖', imageUrl: 'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=400&h=500&fit=crop&q=80', rating: 4.2, reviewCount: 56, sizes: ['28','30','32','34'], colors: ['Beige','White','Navy'], category: 'men', subcategory: 'trousers', color: 'Beige' },
  { id: 14, name: 'Wrap Midi Dress', brand: 'Zara', price: 3299, originalPrice: 5999, imageEmoji: '👗', imageUrl: 'https://images.unsplash.com/photo-1525507119028-ed4c629a60a3?w=400&h=500&fit=crop&q=80', rating: 4.6, reviewCount: 201, sizes: ['XS','S','M','L','XL'], colors: ['Purple','Red','Forest Green'], category: 'women', subcategory: 'dresses', color: 'Purple', isNew: true },
  { id: 15, name: 'Sports Hoodie', brand: 'Adidas', price: 2899, originalPrice: 4999, imageEmoji: '🧥', imageUrl: 'https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=400&h=500&fit=crop&q=80', rating: 4.4, reviewCount: 145, sizes: ['S','M','L','XL','XXL'], colors: ['Grey','Black','Navy'], category: 'men', subcategory: 'sportswear', color: 'Grey' },
  { id: 16, name: 'Printed Leggings', brand: 'Nykaa Fashion', price: 699, originalPrice: 1499, imageEmoji: '🩱', imageUrl: 'https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=400&h=500&fit=crop&q=80', rating: 4.1, reviewCount: 89, sizes: ['XS','S','M','L','XL'], colors: ['Black','Navy','Dark Green'], category: 'women', subcategory: 'leggings', color: 'Black' },
  { id: 17, name: 'Denim Jacket', brand: "Levi's", price: 4499, originalPrice: 7999, imageEmoji: '🧥', imageUrl: 'https://images.unsplash.com/photo-1544022613-e87ca75a784a?w=400&h=500&fit=crop&q=80', rating: 4.5, reviewCount: 167, sizes: ['S','M','L','XL'], colors: ['Light Blue','Dark Blue','Black'], category: 'men', subcategory: 'jackets', color: 'Blue' },
  { id: 18, name: 'Ethnic Palazzo Set', brand: 'W', price: 2299, originalPrice: 4499, imageEmoji: '👘', imageUrl: 'https://images.unsplash.com/photo-1567013127542-490d757e51fc?w=400&h=500&fit=crop&q=80', rating: 4.3, reviewCount: 134, sizes: ['XS','S','M','L','XL'], colors: ['Orange','Teal','Mustard'], category: 'women', subcategory: 'ethnic', color: 'Orange', isNew: true },
  { id: 19, name: 'Kids Canvas Sneakers', brand: 'Nike', price: 2499, originalPrice: 3999, imageEmoji: '👟', imageUrl: 'https://images.unsplash.com/photo-1560769629-975ec94e6a86?w=400&h=500&fit=crop&q=80', rating: 4.6, reviewCount: 78, sizes: ['UK2','UK3','UK4','UK5'], colors: ['White','Black','Pink'], category: 'kids', subcategory: 'footwear', color: 'White', isNew: true },
  { id: 20, name: 'Cocktail Bodycon Dress', brand: 'Forever 21', price: 1999, originalPrice: 4999, imageEmoji: '👗', imageUrl: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=500&fit=crop&q=80', rating: 4.0, reviewCount: 112, sizes: ['XS','S','M','L'], colors: ['Black','Red','Royal Blue'], category: 'women', subcategory: 'dresses', color: 'Black' },
];

const SORT_OPTIONS = [
  { value: 'recommended', label: 'Recommended' },
  { value: 'newest', label: 'New Arrivals' },
  { value: 'price_low', label: 'Price: Low to High' },
  { value: 'price_high', label: 'Price: High to Low' },
  { value: 'discount', label: 'Better Discount' },
  { value: 'rating', label: 'Customer Rating' },
  { value: 'popular', label: 'Popularity' },
];

const FILTERS = {
  gender: ['Men', 'Women', 'Boys', 'Girls', 'Unisex'],
  category: ['T-Shirts', 'Shirts', 'Jeans', 'Dresses', 'Sarees', 'Kurtis', 'Tops', 'Leggings', 'Footwear', 'Accessories', 'Jackets', 'Blazers', 'Shorts', 'Skirts', 'Ethnic Wear'],
  brand: ['Zara', 'H&M', "Levi's", 'Nike', 'Adidas', 'Puma', 'Mango', 'Forever 21', 'Biba', 'W', 'Van Heusen', 'Caprese', 'Steve Madden'],
  price: [
    { label: 'Under ₹500', min: 0, max: 500 },
    { label: '₹500 - ₹1000', min: 500, max: 1000 },
    { label: '₹1000 - ₹2000', min: 1000, max: 2000 },
    { label: '₹2000 - ₹5000', min: 2000, max: 5000 },
    { label: 'Above ₹5000', min: 5000, max: Infinity },
  ],
  discount: ['10% and above', '20% and above', '30% and above', '40% and above', '50% and above', '60% and above', '70% and above'],
  rating: ['4★ & above', '3★ & above'],
  color: ['Black', 'White', 'Blue', 'Red', 'Pink', 'Green', 'Yellow', 'Orange', 'Purple', 'Brown', 'Grey', 'Beige', 'Multicolor'],
};

export default function ProductList() {
  const { category } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(s => s.auth);
  const wishlistItems = useSelector(s => s.wishlist.items);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState('recommended');
  const [viewMode, setViewMode] = useState('grid');
  const [showFilter, setShowFilter] = useState(true);
  const [mobileFilter, setMobileFilter] = useState(false);
  const [filters, setFilters] = useState({
    brand: [], price: null, discount: null, rating: null, color: [], subcategory: []
  });
  const [expandedFilter, setExpandedFilter] = useState({ brand: true, price: true, discount: false, rating: false, color: false });
  const searchQuery = searchParams.get('search');
  const saleFilter = searchParams.get('sale');

  useEffect(() => {
    setLoading(true);
    const params = { category, sort };
    if (searchQuery) params.search = searchQuery;
    api.get('/api/products', { params })
      .then(res => setProducts(res.data.content || res.data || []))
      .catch(() => setProducts(MOCK_PRODUCTS))
      .finally(() => setLoading(false));
  }, [category, sort, searchQuery]);

  const isWishlisted = id => wishlistItems.some(i => i.id === id);

  const handleWishlist = (e, product) => {
    e.preventDefault(); e.stopPropagation();
    if (!isAuthenticated) { navigate('/login'); return; }
    if (isWishlisted(product.id)) {
      dispatch(removeFromWishlist(product.id));
      toast.info('Removed from wishlist');
    } else {
      dispatch(addToWishlist(product));
      toast.success('Added to wishlist!');
    }
  };

  const handleAddToCart = (e, product) => {
    e.preventDefault(); e.stopPropagation();
    if (!isAuthenticated) { navigate('/login'); return; }
    dispatch(addToCart({ ...product, quantity: 1, selectedSize: product.sizes?.[0] || 'M' }));
    toast.success('Added to bag!');
  };

  const toggleFilter = (type, value) => {
    setFilters(prev => {
      if (Array.isArray(prev[type])) {
        return { ...prev, [type]: prev[type].includes(value) ? prev[type].filter(v => v !== value) : [...prev[type], value] };
      }
      return { ...prev, [type]: prev[type] === value ? null : value };
    });
  };

  const clearAllFilters = () => setFilters({ brand: [], price: null, discount: null, rating: null, color: [], subcategory: [] });

  const activeFilterCount = filters.brand.length + filters.color.length + filters.subcategory.length
    + (filters.price ? 1 : 0) + (filters.discount ? 1 : 0) + (filters.rating ? 1 : 0);

  const filteredProducts = products.filter(p => {
    if (filters.brand.length && !filters.brand.includes(p.brand)) return false;
    if (filters.color.length && !filters.color.includes(p.color)) return false;
    if (filters.price) {
      const range = FILTERS.price.find(r => r.label === filters.price);
      if (range && (p.price < range.min || p.price > range.max)) return false;
    }
    if (filters.discount) {
      const minDisc = parseInt(filters.discount);
      const disc = p.originalPrice ? Math.round((1 - p.price / p.originalPrice) * 100) : 0;
      if (disc < minDisc) return false;
    }
    if (filters.rating) {
      const minRating = parseFloat(filters.rating);
      if ((p.rating || 0) < minRating) return false;
    }
    if (saleFilter) {
      if (!p.originalPrice || p.originalPrice <= p.price) return false;
    }
    return true;
  });

  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sort === 'price_low') return a.price - b.price;
    if (sort === 'price_high') return b.price - a.price;
    if (sort === 'rating') return (b.rating || 0) - (a.rating || 0);
    if (sort === 'discount') {
      const da = a.originalPrice ? (1 - a.price / a.originalPrice) : 0;
      const db = b.originalPrice ? (1 - b.price / b.originalPrice) : 0;
      return db - da;
    }
    return 0;
  });

  const title = category ? category.charAt(0).toUpperCase() + category.slice(1) : searchQuery ? `Results for "${searchQuery}"` : 'All Products';

  return (
    <div className="product-list-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <Link to="/">Home</Link> <span>/</span>
        {category && <><Link to="/products">All</Link><span>/</span></>}
        <span>{title}</span>
      </div>

      <div className="product-list-layout">
        {/* Filter Sidebar */}
        <aside className={`filter-sidebar${showFilter ? '' : ' collapsed'}${mobileFilter ? ' mobile-open' : ''}`}>
          <div className="filter-header">
            <h3>FILTERS {activeFilterCount > 0 && <span className="filter-count">{activeFilterCount}</span>}</h3>
            {activeFilterCount > 0 && (
              <button className="clear-filters-btn" onClick={clearAllFilters}>CLEAR ALL</button>
            )}
            <button className="mobile-close-filter" onClick={() => setMobileFilter(false)}><FiX /></button>
          </div>

          {/* Active Filter Tags */}
          {activeFilterCount > 0 && (
            <div className="active-filters">
              {filters.brand.map(b => <span key={b} className="filter-tag">{b} <FiX onClick={() => toggleFilter('brand', b)} /></span>)}
              {filters.color.map(c => <span key={c} className="filter-tag">{c} <FiX onClick={() => toggleFilter('color', c)} /></span>)}
              {filters.price && <span className="filter-tag">{filters.price} <FiX onClick={() => toggleFilter('price', filters.price)} /></span>}
              {filters.discount && <span className="filter-tag">{filters.discount} <FiX onClick={() => toggleFilter('discount', filters.discount)} /></span>}
              {filters.rating && <span className="filter-tag">{filters.rating} <FiX onClick={() => toggleFilter('rating', filters.rating)} /></span>}
            </div>
          )}

          {/* Brand Filter */}
          <FilterSection title="BRAND" expanded={expandedFilter.brand} onToggle={() => setExpandedFilter(p => ({ ...p, brand: !p.brand }))}>
            {FILTERS.brand.map(brand => (
              <label key={brand} className="filter-option">
                <input type="checkbox" checked={filters.brand.includes(brand)} onChange={() => toggleFilter('brand', brand)} />
                <span>{brand}</span>
              </label>
            ))}
          </FilterSection>

          {/* Price Filter */}
          <FilterSection title="PRICE" expanded={expandedFilter.price} onToggle={() => setExpandedFilter(p => ({ ...p, price: !p.price }))}>
            {FILTERS.price.map(r => (
              <label key={r.label} className="filter-option">
                <input type="radio" name="price" checked={filters.price === r.label} onChange={() => toggleFilter('price', r.label)} />
                <span>{r.label}</span>
              </label>
            ))}
          </FilterSection>

          {/* Discount Filter */}
          <FilterSection title="DISCOUNT" expanded={expandedFilter.discount} onToggle={() => setExpandedFilter(p => ({ ...p, discount: !p.discount }))}>
            {FILTERS.discount.map(d => (
              <label key={d} className="filter-option">
                <input type="radio" name="discount" checked={filters.discount === d} onChange={() => toggleFilter('discount', d)} />
                <span>{d}</span>
              </label>
            ))}
          </FilterSection>

          {/* Rating Filter */}
          <FilterSection title="CUSTOMER RATINGS" expanded={expandedFilter.rating} onToggle={() => setExpandedFilter(p => ({ ...p, rating: !p.rating }))}>
            {FILTERS.rating.map(r => (
              <label key={r} className="filter-option">
                <input type="radio" name="rating" checked={filters.rating === r} onChange={() => toggleFilter('rating', r)} />
                <span>⭐ {r}</span>
              </label>
            ))}
          </FilterSection>

          {/* Color Filter */}
          <FilterSection title="COLOR" expanded={expandedFilter.color} onToggle={() => setExpandedFilter(p => ({ ...p, color: !p.color }))}>
            <div className="color-filter-grid">
              {FILTERS.color.map(c => (
                <button
                  key={c}
                  className={`color-btn${filters.color.includes(c) ? ' active' : ''}`}
                  onClick={() => toggleFilter('color', c)}
                  title={c}
                >
                  <span className="color-dot" style={{ background: c.toLowerCase() === 'multicolor' ? 'linear-gradient(45deg,red,blue,green)' : c.toLowerCase() === 'nude' ? '#E8C9A0' : c.toLowerCase() === 'beige' ? '#F5F0E8' : c.toLowerCase() }} />
                  <span className="color-label">{c}</span>
                </button>
              ))}
            </div>
          </FilterSection>
        </aside>

        {/* Product Content */}
        <div className="product-content">
          {/* Toolbar */}
          <div className="product-toolbar">
            <div className="toolbar-left">
              <button className="mobile-filter-btn" onClick={() => setMobileFilter(true)}>
                <FiFilter /> FILTER {activeFilterCount > 0 && `(${activeFilterCount})`}
              </button>
              <button className="hide-filter-btn" onClick={() => setShowFilter(!showFilter)}>
                <FiFilter /> {showFilter ? 'Hide' : 'Show'} Filters
              </button>
              <span className="product-count">
                <strong>{sortedProducts.length}</strong> Items
              </span>
            </div>
            <div className="toolbar-right">
              <select
                className="sort-select"
                value={sort}
                onChange={e => setSort(e.target.value)}
              >
                {SORT_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
              <div className="view-toggle">
                <button className={viewMode === 'grid' ? 'active' : ''} onClick={() => setViewMode('grid')}><FiGrid /></button>
                <button className={viewMode === 'list' ? 'active' : ''} onClick={() => setViewMode('list')}><FiList /></button>
              </div>
            </div>
          </div>

          {/* Products */}
          {loading ? (
            <div className="loading-wrapper"><div className="spinner" /><p>Loading products...</p></div>
          ) : sortedProducts.length === 0 ? (
            <div className="empty-state">
              <span style={{ fontSize: 80 }}>😕</span>
              <h2>No products found</h2>
              <p>Try adjusting your filters or search terms</p>
              <button className="btn btn-primary" onClick={clearAllFilters}>Clear All Filters</button>
            </div>
          ) : (
            <div className={`products-grid${viewMode === 'list' ? ' list-view' : ''}`}>
              {sortedProducts.map(product => (
                <ProductCard
                  key={product.id}
                  product={product}
                  isWishlisted={isWishlisted(product.id)}
                  onWishlist={e => handleWishlist(e, product)}
                  onAddToCart={e => handleAddToCart(e, product)}
                  viewMode={viewMode}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Mobile Filter Overlay */}
      {mobileFilter && <div className="filter-overlay" onClick={() => setMobileFilter(false)} />}
    </div>
  );
}

function FilterSection({ title, expanded, onToggle, children }) {
  return (
    <div className="filter-section">
      <button className="filter-section-header" onClick={onToggle}>
        <span>{title}</span>
        {expanded ? <FiChevronUp /> : <FiChevronDown />}
      </button>
      {expanded && <div className="filter-section-body">{children}</div>}
    </div>
  );
}

function ProductCard({ product, isWishlisted, onWishlist, onAddToCart, viewMode }) {
  const navigate = useNavigate();
  const discount = product.originalPrice
    ? Math.round((1 - product.price / product.originalPrice) * 100) : 0;
  return (
    <div className={`pl-product-card${viewMode === 'list' ? ' list' : ''}`} onClick={() => navigate(`/product/${product.id}`)}>
      <div className="pl-product-image">
        <span className="pl-product-emoji">{product.imageEmoji || '👗'}</span>
        {product.imageUrl && <img src={product.imageUrl} alt={product.name} loading="lazy" />}
        {discount > 0 && <span className="pl-badge">{discount}% OFF</span>}
        <button className={`pl-wishlist-btn${isWishlisted ? ' active' : ''}`} onClick={onWishlist}>
          <FiHeart />
        </button>
      </div>
      <div className="pl-product-info">
        <p className="pl-brand">{product.brand}</p>
        <p className="pl-name">{product.name}</p>
        <div className="pl-price-row">
          <span className="pl-price">₹{product.price?.toLocaleString()}</span>
          {product.originalPrice && <span className="pl-original">₹{product.originalPrice?.toLocaleString()}</span>}
          {discount > 0 && <span className="pl-discount">({discount}% off)</span>}
        </div>
        {product.rating && (
          <span className="pl-rating"><FiStar /> {product.rating} ({product.reviewCount})</span>
        )}
        {viewMode === 'list' && product.sizes && (
          <div className="pl-sizes">
            {product.sizes.map(s => <span key={s} className="pl-size-chip">{s}</span>)}
          </div>
        )}
        <button className="pl-add-btn" onClick={onAddToCart}>Add to Bag</button>
      </div>
    </div>
  );
}
